<template>
  <div v-if="$apollo.loading">
    <v-skeleton-loader v-for="count of 3" :key="count" type="list-item-two-line" />
  </div>
  <v-timeline v-else dense align-top class="pt-0 mx-n2">
    <v-timeline-item
      v-for="(block, index) in recommendedWorkoutJourney"
      :key="block.id"
      small
      fill-dot
      :color="index == 0 ? 'pink' : 'grey-navy'"
      :class="{ 'pb-0': index == recommendedWorkoutJourney.length - 1 }"
    >
      <template v-slot:icon>
        <span class="white--text">{{ index + 1 }}</span>
      </template>
      <span class="grey-navy--text">{{ block.weeks }}</span>
      <block-header-card
        :title="block.title"
        :avatarPicture="block.leadInstructor.userProfile.profilePicture"
        :secondaryAvatarPicture="secondaryInstructorProfilePic(block)"
        :subTitle="instructorNames(block)"
        accentColor="pink"
        :showDone="block.hasCompleted"
        class="background-grey"
        @click="$emit('block-clicked', block.id)"
      />
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import { RECOMMENDED_WORKOUT_JOURNEY_QUERY } from "@/constants/graphql/blocks/workoutblocks";
import BlockHeaderCard from "@/components/workout_blocks/BlockHeaderCard";

export default {
  name: "RecommendationTimeline",
  components: {
    BlockHeaderCard,
  },
  props: {
    userId: {
      type: [String, Number],
      required: true,
    },
  },
  methods: {
    secondaryInstructor(block) {
      return block.secondaryInstructor ?? null;
    },
    secondaryInstructorProfilePic(block) {
      return this.secondaryInstructor(block)?.userProfile?.profilePicture;
    },
    instructorNames(block) {
      let secondaryInstructor = this.secondaryInstructor(block)?.firstName;
      return `${block.leadInstructor.firstName}${secondaryInstructor ? " & " + secondaryInstructor : ""}`;
    },
  },
  apollo: {
    recommendedWorkoutJourney: {
      query: RECOMMENDED_WORKOUT_JOURNEY_QUERY,
      variables() {
        return {
          userId: this.userId,
        };
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        let blocks = data.recommendedWorkoutJourney;
        let week = 1;
        blocks.forEach((block) => {
          let weeks = block.duration / 7;
          if (weeks > 1) {
            block.weeks = `Weeks ${week}—${week + (weeks - 1)}`;
          } else {
            block.weeks = `Week ${week}`;
          }

          week += weeks;
        });

        return blocks;
      },
    },
  },
};
</script>
